import { render, staticRenderFns } from "./Historycate.vue?vue&type=template&id=37219e59&"
import script from "./Historycate.vue?vue&type=script&lang=js&"
export * from "./Historycate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports